module.exports = __webpack_public_path__ + "img/10017.36e474e7.jpg";